// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { teasers as T } from '../../../opopular/assets/teasers';
import { PageBlockTypes as p } from '@xprog/prensa/types'

import { addRelativeWidthToTeaser } from './utils'

const TeaserCard = addRelativeWidthToTeaser(T.TeaserCard, 'calc(calc(100% - calc(24px * 3)) / 4)')

export const LayoutGrid4: p.SlotConfigProps = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        default: [T.TeaserCard, TeaserCard],
      }
    },
    TemplateSideBox: {
      slotLeft: {
        default: [T.TeaserImageLeftSq, T.TeaserImageLeftSm]
      }
    },
    TemplateSideBoxColumnist: {
      slotLeft: {
        default: [T.TeaserColumnist, T.TeaserColumnist]
      }
    },
    TemplateSideBoxNoTitle: {
      slotLeft: {
        default: [T.TeaserImageLeftSq, T.TeaserImageLeftSm],
        '1': [T.TeaserImageTop, T.TeaserImageTop]
      }
    }
  }
}